import React from 'react';

export default function Cell(props){
	
	return (
		<button className="square" onClick={() => props.onClick()}>{props.value}</button>
	);
	
}


// WEBPACK FOOTER //
// ./src/cell.js